(() => {
  const desktopHover = window.matchMedia('(hover: hover) and (min-width: 1025px)');
  const secondarySelector = '.template-collection .sn-secondary-deferred';
  let prefetchLink = null;
  let prefetchTimer = null;
  let pendingPrefetchUrl = '';

  function hydrateSecondary(media) {
    if (!desktopHover.matches || !media || media.dataset.snSecondaryLoading === 'true') return;

    const image = media.querySelector('[data-sn-secondary-image]');
    if (!image?.dataset.src) return;

    media.dataset.snSecondaryLoading = 'true';

    let settled = false;
    let revealRequested = false;
    let timeout = 0;

    const finish = (loaded) => {
      if (settled) return;
      settled = true;
      window.clearTimeout(timeout);
      media.classList.toggle('sn-secondary-ready', loaded);
      media.classList.toggle('sn-secondary-failed', !loaded);
    };
    timeout = window.setTimeout(() => finish(false), 5000);

    const revealWhenDecoded = async () => {
      if (revealRequested || image.naturalWidth === 0) return;
      revealRequested = true;
      try {
        if (typeof image.decode === 'function') await image.decode();
      } catch (_error) {
        if (!image.complete || image.naturalWidth === 0) {
          finish(false);
          return;
        }
      }
      requestAnimationFrame(() => requestAnimationFrame(() => finish(true)));
    };

    image.addEventListener('load', revealWhenDecoded, { once: true });
    image.addEventListener('error', () => finish(false), { once: true });

    image.loading = 'eager';
    if (image.dataset.srcset) image.srcset = image.dataset.srcset;
    image.src = image.dataset.src;
    image.removeAttribute('data-srcset');
    image.removeAttribute('data-src');

    if (image.complete && image.naturalWidth > 0) revealWhenDecoded();
  }

  function secondaryMediaFromEvent(event) {
    return event.target.closest?.(secondarySelector)
      || event.target.closest?.('.template-collection card-media, .template-collection .card__media')
        ?.querySelector('.sn-secondary-deferred');
  }

  function collectionLinkFromEvent(event) {
    const anchor = event.target.closest?.('a[href]');
    if (!anchor || anchor.target === '_blank' || anchor.hasAttribute('download')) return null;

    const url = new URL(anchor.href, window.location.href);
    if (url.origin !== window.location.origin || !url.pathname.includes('/collections/')) return null;
    if (url.href === window.location.href) return null;
    return url;
  }

  function mayPrefetch() {
    const connection = navigator.connection;
    return !connection?.saveData && !['slow-2g', '2g'].includes(connection?.effectiveType);
  }

  function prefetch(url) {
    if (!url || !mayPrefetch() || prefetchLink?.href === url.href) return;

    prefetchLink?.remove();
    prefetchLink = document.createElement('link');
    prefetchLink.rel = 'prefetch';
    prefetchLink.as = 'document';
    prefetchLink.href = url.href;
    document.head.appendChild(prefetchLink);
  }

  function schedulePrefetch(url) {
    window.clearTimeout(prefetchTimer);
    pendingPrefetchUrl = url?.href || '';
    if (!url) return;
    prefetchTimer = window.setTimeout(() => {
      if (pendingPrefetchUrl === url.href) prefetch(url);
    }, 80);
  }

  document.addEventListener('pointerover', (event) => {
    const media = secondaryMediaFromEvent(event);
    if (media) hydrateSecondary(media);

    if (event.pointerType !== 'touch') schedulePrefetch(collectionLinkFromEvent(event));
  }, { passive: true });

  document.addEventListener('pointerout', (event) => {
    const anchor = event.target.closest?.('a[href]');
    if (anchor && !anchor.contains(event.relatedTarget)) schedulePrefetch(null);
  }, { passive: true });

  document.addEventListener('focusin', (event) => {
    const media = secondaryMediaFromEvent(event);
    if (media) hydrateSecondary(media);
  });

  document.addEventListener('touchstart', (event) => {
    prefetch(collectionLinkFromEvent(event));
  }, { passive: true });

  document.addEventListener('sn:market-invalidated', () => {
    window.clearTimeout(prefetchTimer);
    pendingPrefetchUrl = '';
    prefetchLink?.remove();
    prefetchLink = null;
  });
})();
